// extracted by mini-css-extract-plugin
export default {"toggleGroup":"LanguageToggle_toggleGroup__Biq2w","toggleButton":"LanguageToggle_toggleButton__gxTUv","active":"LanguageToggle_active__ZyXUj"};